export default "__VITE_ASSET__CQ9OYQwU__"